var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_335_175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H100V100H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_335_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.127 1.46485H23.1113C25.1035 1.46485 26.7187 3.08008 26.7187 5.07227V23.1113C26.7187 25.1035 25.1035 26.7188 23.1113 26.7188H5.07226C3.08008 26.7188 1.46484 25.1035 1.46484 23.1113V5.07227C1.46484 3.08008 3.08008 1.46485 5.07226 1.46485H6.29102",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10742 20.4053L13.8488 7.95606C13.9457 7.71914 14.2811 7.71895 14.3783 7.95547L19.0768 20.4053",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 17.3049H17.6215",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 58.2871H5.07227C3.07988 58.2871 1.46484 56.6719 1.46484 54.6797V36.6406C1.46484 34.6484 3.07988 33.0332 5.07227 33.0332H23.1113C25.1035 33.0332 26.7187 34.6484 26.7187 36.6406V54.6797C26.7187 55.457 26.4727 56.1758 26.0547 56.7637",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 42.2513C16.8115 43.856 15.5107 45.1568 13.9061 45.1568C13.1104 45.1568 10.2383 45.1697 10.2383 45.1697V42.2513V39.3458H13.9061C15.5107 39.3458 16.8115 40.6466 16.8115 42.2513Z",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.941 48.7207C17.9439 48.667 17.9451 48.6129 17.9451 48.5586C17.9451 46.6816 16.4236 45.1604 14.5469 45.1604H10.2383V51.9727L10.4352 51.9707",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 7.77832H43.6863",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 14.0918H39.7404",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 20.4053H39.7404",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 39.3459H43.6863",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 45.6594H39.7404",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0322 51.9729H39.7404",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9598 26.719H59.9213C57.9285 26.719 56.3135 25.1038 56.3135 23.1112V5.07271C56.3135 3.08013 57.9285 1.4649 59.9213 1.4649H77.9598C79.9523 1.4649 81.5676 3.08013 81.5676 5.07271V23.1112C81.5676 25.1038 79.9523 26.719 77.9598 26.719Z",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6383 8.85669C72.6307 8.17603 71.4158 7.77837 70.1084 7.77837C66.6215 7.77837 63.7949 10.6051 63.7949 14.092C63.7949 17.5788 66.6215 20.4055 70.1084 20.4055C71.5246 20.4055 72.6895 19.9393 73.5734 19.1518C73.7562 18.9889 73.9271 18.8124 74.0857 18.6231",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9414 33.0332H77.959C79.9531 33.0332 81.5682 34.6484 81.5682 36.6406V54.6797C81.5682 56.6719 79.9531 58.2871 77.959 58.2871H59.9217C57.9295 58.2871 56.3145 56.6719 56.3145 54.6797V36.6406C56.3145 34.6484 57.9295 33.0332 59.9217 33.0332H62.1055",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6025 39.359V51.7678",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2779 45.6594C73.2779 49.1385 71.3469 51.8916 68.2834 51.9452C67.2637 51.9629 64.6281 51.9729 64.6281 51.9729C64.6281 51.9729 64.6117 47.3993 64.6117 45.6456C64.6117 44.2051 64.6025 39.3459 64.6025 39.3459H68.1789C71.5391 39.3459 73.2779 42.1803 73.2779 45.6594Z",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 7.77832H98.535",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 14.0918H94.5891",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 20.4053H94.5891",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 39.3459H98.535",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 45.6594H94.5891",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8809 51.9729H94.5891",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3203 98.5352L17.7988 96.707C16.416 95.7012 15.3984 94.2793 14.8926 92.6484L9.8457 76.3105C9.72656 75.9219 9.66797 75.5313 9.66797 75.1445C9.66797 73.459 10.7578 71.8984 12.4512 71.375C14.5332 70.7324 16.7441 71.8984 17.3865 73.9805L10.3984 51.3594C9.74023 49.2324 10.9727 46.9707 13.1406 46.3848C15.207 45.8281 17.334 47.0762 17.9648 49.1191L21.8965 61.8477C21.2402 59.7207 22.4727 57.459 24.6406 56.8731C26.707 56.3164 28.834 57.5645 29.4648 59.6113L30.6035 63.2891C29.9453 61.1602 31.1777 58.9004 33.3457 58.3145C35.4121 57.7559 37.5391 59.0059 38.1719 61.0508L39.3652 64.918C38.709 62.791 39.9414 60.5293 42.1094 59.9434C44.1758 59.3848 46.3027 60.6348 46.9336 62.6777L49.2637 70.2188",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2812 76.75L53.084 82.5859C53.2754 83.2012 53.3887 83.8379 53.424 84.4844L53.8164 91.6348L55.9475 98.5352",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8975 61.8486L25.5082 73.5359",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6025 63.2891L33.0484 71.2063",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3076 64.7299L40.5889 68.877",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 73.9804L20.3559 83.5943L19.1834 85.8148",
    stroke: "#1B75BB",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.a17374e6f5eaea495e644c4106b93c77.svg";
export { ForwardRef as ReactComponent };